// extracted by mini-css-extract-plugin
export default {"collapse":"AssistantInput-module__collapse--dd9b6"};